import axios from "@/plugins/axios";
import applications from "./applications";
import attendances from "./attendances";
import files from "./files";
import thumb from "./thumb";
import units from "./units";

let url = "/api/console/programs";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
    applications,
    attendances,
    files,
    thumb,
    units,
};
